import React from 'react'
import { sources } from '../data/sources'
import { useI18n } from '../i18n/LanguageContext'

function Footer() {
  const { t } = useI18n()
  const navLinks = [
    { id: 'overview', label: t.nav.overview },
    { id: 'explore', label: t.nav.explore },
    { id: 'timeline', label: t.nav.history },
    { id: 'places', label: t.nav.places },
    { id: 'news', label: t.nav.news },
    { id: 'map', label: t.nav.map },
    { id: 'gallery', label: t.nav.gallery },
  ]

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <p className="footer-brand">Nanovitsa <span lang="bg">Нановица</span></p>
          <p>{t.footer.tagline}</p>
          <ul className="footer-nav">
            {navLinks.map((link) => (
              <li key={link.id}><a href={`#${link.id}`}>{link.label}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <h2>{t.footer.sourcesTitle}</h2>
          <ul className="source-list">
            {sources.map((source) => (
              <li key={source.href}>
                <a href={source.href} target="_blank" rel="noopener noreferrer">{source.label}</a>
                <span> – {source.publisher}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2>{t.footer.photosTitle}</h2>
          <p>{t.footer.photosText}</p>
        </div>
      </div>
      <div className="container footer-base">
        <p>{t.footer.disclaimer}</p>
      </div>
    </footer>
  )
}

export default Footer
